"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReplayTrails = void 0;
const TrailShader_1 = require("./Graphics/TrailShader/TrailShader");
const COLORS = [
    [0.91, 0.27, 0.38, 1.0],
    [0.30, 0.69, 0.31, 1.0],
    [0.25, 0.47, 0.85, 1.0],
    [1.00, 0.76, 0.03, 1.0],
    [1.00, 0.60, 0.00, 1.0],
    [0.58, 0.40, 0.74, 1.0],
    [0.00, 0.78, 0.78, 1.0],
    [0.96, 0.26, 0.82, 1.0],
];
class ReplayTrails {
    constructor(context) {
        this.trailVisible = true;
        this.trailSize = 2;
        this.playerMarkerModel = 'box';
        this.shader = null;
        this.trailBuffer = null;
        this.dotBuffer = null;
        this.entries = [];
        this.context = context;
        this.shader = TrailShader_1.TrailShader.init(context);
        if (this.shader) {
            this.trailBuffer = context.gl.createBuffer();
            this.dotBuffer = context.gl.createBuffer();
        }
    }
    addEntry(name, replay) {
        var _a, _b;
        const colorIndex = this.entries.length % COLORS.length;
        const color = COLORS[colorIndex];
        const frames = (_b = (_a = replay.replay) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.frames;
        const count = frames ? frames.length : 0;
        const positions = new Float32Array(count * 3);
        const colors = new Float32Array(count * 4);
        const sizes = new Float32Array(count);
        if (frames) {
            for (let i = 0; i < count; i++) {
                const f = frames[i];
                positions[i * 3] = f.origin[0];
                positions[i * 3 + 1] = f.origin[1];
                positions[i * 3 + 2] = f.origin[2];
                colors[i * 4] = color[0];
                colors[i * 4 + 1] = color[1];
                colors[i * 4 + 2] = color[2];
                colors[i * 4 + 3] = color[3];
                sizes[i] = this.trailSize;
            }
        }
        const dotPositions = new Float32Array(3);
        const dotColors = new Float32Array(4);
        const dotSizes = new Float32Array(1);
        dotColors[0] = color[0];
        dotColors[1] = color[1];
        dotColors[2] = color[2];
        dotColors[3] = color[3];
        dotSizes[0] = 1;
        if (frames && frames.length > 0) {
            dotPositions[0] = frames[0].origin[0];
            dotPositions[1] = frames[0].origin[1];
            dotPositions[2] = frames[0].origin[2];
        }
        const entry = {
            name,
            color,
            replay,
            positions,
            colors,
            sizes,
            dotPositions,
            dotColors,
            dotSizes
        };
        this.entries.push(entry);
        return entry;
    }
    removeEntry(entry) {
        const idx = this.entries.indexOf(entry);
        if (idx !== -1)
            this.entries.splice(idx, 1);
    }
    clear() {
        this.entries.length = 0;
    }
    getEntries() {
        return this.entries;
    }
    updateEntry(entry, currentFrame) {
        var _a, _b;
        const frames = (_b = (_a = entry.replay.replay) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.frames;
        if (!frames || currentFrame < 0 || currentFrame >= frames.length)
            return;
        const f = frames[currentFrame];
        entry.dotPositions[0] = f.origin[0];
        entry.dotPositions[1] = f.origin[1];
        entry.dotPositions[2] = f.origin[2];
    }
    draw(camera, hiddenMarkerReplay = null) {
        if (!this.shader || this.entries.length === 0)
            return;
        const gl = this.context.gl;
        this.shader.useProgram(this.context);
        this.shader.setViewMatrix(this.context, camera.viewMatrix);
        this.shader.setProjectionMatrix(this.context, camera.projectionMatrix);
        this.shader.setPointScale(this.context, camera.projectionMatrix);
        gl.enable(gl.BLEND);
        gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);
        gl.enable(gl.DEPTH_TEST);
        gl.depthFunc(gl.LEQUAL);
        gl.depthMask(true);
        const posLoc = this.shader.getAttribLocation('position');
        const colLoc = this.shader.getAttribLocation('color');
        const sizeLoc = this.shader.getAttribLocation('size');
        this.shader.setPointMode(this.context, true);
        for (const entry of this.entries) {
            if (entry.positions.length === 0)
                continue;
            if (this.trailVisible) {
                entry.sizes.fill(this.trailSize);
                this.drawBuffer(entry.positions, entry.colors, entry.sizes, entry.positions.length / 3, posLoc, colLoc, sizeLoc);
            }
            if (this.playerMarkerModel !== 'off' && entry.replay !== hiddenMarkerReplay) {
                this.drawMarker(entry, posLoc, colLoc, sizeLoc);
            }
        }
        gl.depthMask(true);
        gl.disable(gl.BLEND);
    }
    drawMarker(entry, posLoc, colLoc, sizeLoc) {
        var _a, _b, _c;
        const [x, y, z] = entry.dotPositions;
        const frame = (_c = (_b = (_a = entry.replay.replay) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.frames) === null || _c === void 0 ? void 0 : _c[entry.replay.currentFrame];
        const ducking = !!frame && (frame.buttons & (1 << 1)) !== 0;
        const vertices = this.playerMarkerModel === 'box'
            ? this.boxVertices(x, y, z, ducking)
            : this.capsuleVertices(x, y, z, ducking);
        const colors = new Float32Array((vertices.length / 3) * 4);
        for (let i = 0; i < colors.length; i += 4) {
            colors[i] = entry.color[0];
            colors[i + 1] = entry.color[1];
            colors[i + 2] = entry.color[2];
            colors[i + 3] = 0.72;
        }
        const gl = this.context.gl;
        this.shader.setPointMode(this.context, false);
        gl.bindBuffer(gl.ARRAY_BUFFER, this.trailBuffer);
        gl.bufferData(gl.ARRAY_BUFFER, vertices, gl.DYNAMIC_DRAW);
        gl.enableVertexAttribArray(posLoc);
        gl.vertexAttribPointer(posLoc, 3, gl.FLOAT, false, 0, 0);
        gl.bindBuffer(gl.ARRAY_BUFFER, this.dotBuffer);
        gl.bufferData(gl.ARRAY_BUFFER, colors, gl.DYNAMIC_DRAW);
        gl.enableVertexAttribArray(colLoc);
        gl.vertexAttribPointer(colLoc, 4, gl.FLOAT, false, 0, 0);
        gl.disableVertexAttribArray(sizeLoc);
        gl.vertexAttrib1f(sizeLoc, 1);
        gl.drawArrays(gl.TRIANGLES, 0, vertices.length / 3);
        this.shader.setPointMode(this.context, true);
    }
    boxVertices(x, y, z, ducking) {
        const halfHeight = ducking ? 18 : 36;
        const points = [
            [x - 16, y - 16, z - halfHeight], [x + 16, y - 16, z - halfHeight], [x + 16, y + 16, z - halfHeight], [x - 16, y + 16, z - halfHeight],
            [x - 16, y - 16, z + halfHeight], [x + 16, y - 16, z + halfHeight], [x + 16, y + 16, z + halfHeight], [x - 16, y + 16, z + halfHeight]
        ];
        const faces = [0, 1, 2, 0, 2, 3, 4, 6, 5, 4, 7, 6, 0, 4, 5, 0, 5, 1, 1, 5, 6, 1, 6, 2, 2, 6, 7, 2, 7, 3, 3, 7, 4, 3, 4, 0];
        const result = new Float32Array(faces.length * 3);
        faces.forEach((pointIndex, i) => result.set(points[pointIndex], i * 3));
        return result;
    }
    capsuleVertices(x, y, z, ducking) {
        const segments = 10;
        const height = ducking ? 36 : 72;
        const baseZ = z - height / 2;
        const rings = [[0, 0], [16, height * 0.14], [16, height * 0.86], [0, height]];
        const vertices = [];
        for (let ring = 0; ring < rings.length - 1; ring++) {
            const [radiusA, heightA] = rings[ring];
            const [radiusB, heightB] = rings[ring + 1];
            for (let side = 0; side < segments; side++) {
                const next = (side + 1) % segments;
                const angle = side / segments * Math.PI * 2;
                const nextAngle = next / segments * Math.PI * 2;
                const a = [x + Math.cos(angle) * radiusA, y + Math.sin(angle) * radiusA, baseZ + heightA];
                const b = [x + Math.cos(angle) * radiusB, y + Math.sin(angle) * radiusB, baseZ + heightB];
                const c = [x + Math.cos(nextAngle) * radiusB, y + Math.sin(nextAngle) * radiusB, baseZ + heightB];
                const d = [x + Math.cos(nextAngle) * radiusA, y + Math.sin(nextAngle) * radiusA, baseZ + heightA];
                vertices.push(...a, ...b, ...c, ...a, ...c, ...d);
            }
        }
        return new Float32Array(vertices);
    }
    drawBuffer(positions, colors, sizes, count, posLoc, colLoc, sizeLoc) {
        const gl = this.context.gl;
        gl.bindBuffer(gl.ARRAY_BUFFER, this.trailBuffer);
        gl.bufferData(gl.ARRAY_BUFFER, positions, gl.DYNAMIC_DRAW);
        gl.enableVertexAttribArray(posLoc);
        gl.vertexAttribPointer(posLoc, 3, gl.FLOAT, false, 0, 0);
        gl.bindBuffer(gl.ARRAY_BUFFER, this.dotBuffer);
        gl.bufferData(gl.ARRAY_BUFFER, colors, gl.DYNAMIC_DRAW);
        gl.enableVertexAttribArray(colLoc);
        gl.vertexAttribPointer(colLoc, 4, gl.FLOAT, false, 0, 0);
        const sizeBuffer = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, sizeBuffer);
        gl.bufferData(gl.ARRAY_BUFFER, sizes, gl.DYNAMIC_DRAW);
        gl.enableVertexAttribArray(sizeLoc);
        gl.vertexAttribPointer(sizeLoc, 1, gl.FLOAT, false, 0, 0);
        gl.drawArrays(gl.POINTS, 0, count);
        gl.deleteBuffer(sizeBuffer);
    }
    drawOnMinimap(ctx, projectX, projectY, currentFrames, highlightedReplay) {
        var _a, _b, _c;
        for (const entry of this.entries) {
            const frames = (_b = (_a = entry.replay.replay) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.frames;
            if (!frames)
                continue;
            const currentFrame = (_c = currentFrames.get(entry.replay)) !== null && _c !== void 0 ? _c : 0;
            const r = Math.round(entry.color[0] * 255);
            const g = Math.round(entry.color[1] * 255);
            const b = Math.round(entry.color[2] * 255);
            const step = Math.max(1, Math.floor(frames.length / 350));
            ctx.beginPath();
            let hasPoint = false;
            for (let i = 0; i <= currentFrame && i < frames.length; i += step) {
                const f = frames[i];
                const px = projectX(f.origin[0]);
                const py = projectY(f.origin[1]);
                if (hasPoint) {
                    ctx.lineTo(px, py);
                }
                else {
                    ctx.moveTo(px, py);
                    hasPoint = true;
                }
            }
            ctx.strokeStyle = `rgba(${r},${g},${b},0.9)`;
            ctx.lineWidth = 1.4;
            ctx.stroke();
            ctx.fillStyle = `rgba(${r},${g},${b},0.8)`;
            for (let i = 0; i <= currentFrame && i < frames.length; i += step) {
                const f = frames[i];
                const px = projectX(f.origin[0]);
                const py = projectY(f.origin[1]);
                ctx.fillRect(px - 1, py - 1, 2, 2);
            }
            if (currentFrame < frames.length) {
                const f = frames[currentFrame];
                const px = projectX(f.origin[0]);
                const py = projectY(f.origin[1]);
                const isHighlighted = entry.replay === highlightedReplay;
                ctx.beginPath();
                ctx.arc(px, py, 3, 0, Math.PI * 2);
                ctx.fillStyle = `rgb(${r},${g},${b})`;
                ctx.fill();
                if (isHighlighted) {
                    ctx.beginPath();
                    ctx.arc(px, py, 5, 0, Math.PI * 2);
                    ctx.strokeStyle = '#fff';
                    ctx.lineWidth = 1.5;
                    ctx.stroke();
                }
            }
        }
    }
}
exports.ReplayTrails = ReplayTrails;
